import { lazy } from 'react';

const TVBet = lazy(
	() =>
		import(
			/* webpackChunkName: "tvbet" */
			'./tvbet.js'
		)
);

export default TVBet;
